import React, { useContext } from "react";
import { useFormik } from "formik";
import { addLessonTemplate, updateLessonTemplate } from "../../api/Api";
import { showToast } from "../../utils/toastUtils";
import AddUpdateTemplateModalUI from "./AddUpdateTemplateModalUI";
import { riskValidationSchema } from "../../utils/validations";
import {OrganizationContext} from "../../contexts/OrganizationContextProvider";

function AddUpdateLessonTemplateModal(
  { show,
   handleClose,
   refresh, 
   template,
   defaultDescription // defaultDescription is a string that will be used as the default value for the description field  
   }) {

  const { data: organization } = useContext(OrganizationContext)
  
  const formik = useFormik({
    initialValues: {
      title: template?.title || "",
      description: template?.description || defaultDescription || "",
      organization_id: organization?.current_organization?.id || "",
    },
    enableReinitialize: true,
    validationSchema: riskValidationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      try {
        let response;
        if (template) {
          response = await updateLessonTemplate(template.id, values);
        } else {
          response = await addLessonTemplate(values);
        }

        if (response.status === 201 || response.status === 200) {
          showToast("Lesson template saved successfully", "success");
          refresh();
          handleClose();
        } else {
          showToast(response.message || "Failed to save lesson template", "error");
        }
      } finally {
        setSubmitting(false);
      }
    },
  });

  return (
    <AddUpdateTemplateModalUI
      show={show}
      handleClose={handleClose}
      title={template ? "Update Template" : "Add New Template"}
      values={formik.values}
      handleChange={formik.handleChange}
      handleSubmit={formik.handleSubmit}
      isSubmitting={formik.isSubmitting}
      errors={formik.errors}
      touched={formik.touched}
      setFieldValue={formik.setFieldValue}
      refresh={refresh}
      isEdit={!!template} // true if editing an existing template
    />
  );
}

export default AddUpdateLessonTemplateModal;
